'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.truncate = exports.slugify = exports.isTextSelected = exports.leftPad = exports.toNumber = exports.interpolate = exports.toKebabCase = void 0;
var tslib_1 = require("tslib");
var marked_1 = tslib_1.__importDefault(require("marked"));
function toKebabCase(name) {
    return name.toLowerCase().replace(/ /g, '-');
}
exports.toKebabCase = toKebabCase;
var REGEXP_INTERPOLATE_PARAMS = /\{{1,2}\s*([A-Z\d\-\_\.]+)\s*\}{1,2}/gi;
function interpolate(content, params, isMarkdown) {
    if (isMarkdown === void 0) { isMarkdown = false; }
    var result = content || '';
    result = result.replace(REGEXP_INTERPOLATE_PARAMS, function (match, key) {
        if (params && key in params) {
            return params[key];
        }
        return match;
    });
    if (isMarkdown) {
        result = marked_1.default(result);
    }
    return result;
}
exports.interpolate = interpolate;
/**
 * Parses a string representation of a number into an
 * integer value.
 * @param value
 */
function toNumber(value) {
    if (value === null) {
        return 0;
    }
    var parsedNumber = parseInt(value, 10);
    return Number.isNaN(parsedNumber) ? 0 : parsedNumber;
}
exports.toNumber = toNumber;
/**
 * Left pads a value
 */
function leftPad(n, length, padding) {
    if (length === void 0) { length = 2; }
    if (padding === void 0) { padding = '0'; }
    return (n === null ? '' : n).toString().padStart(length, padding);
}
exports.leftPad = leftPad;
/**
 * Checks if the selected text is the value passed
 * or included in it
 */
function isTextSelected(value) {
    if (!document.getSelection) {
        return false;
    }
    var selection = document.getSelection();
    if (!selection) {
        return false;
    }
    return value.includes(selection.toString());
}
exports.isTextSelected = isTextSelected;
/**
 * Converts the specified string to a slug value
 * @param text text to convert
 */
function slugify(text) {
    if (!text) {
        return '';
    }
    return text
        .toLowerCase()
        .replace(/[^a-z0-9\u0430-\u044f]+/g, '-')
        .replace(/^-+|-+$/g, '');
}
exports.slugify = slugify;
/**
 * Truncates strings at given limit
 * @param text
 * @param limit
 * @param truncateWord
 * @param appendString
 * @returns string
 */
function truncate(text, limit, truncateWord, appendString) {
    if (truncateWord === void 0) { truncateWord = true; }
    if (appendString === void 0) { appendString = '...'; }
    if (text.length < limit) {
        return text;
    }
    var result = text.substr(0, limit);
    if (!truncateWord) {
        return "" + result + appendString;
    }
    if (result.charAt(limit) === ' ') {
        return "" + result + appendString;
    }
    return "" + result.substr(0, result.lastIndexOf(' ')) + appendString;
}
exports.truncate = truncate;
